import { chakra } from '@chakra-ui/react'
import { CustomerNFT } from './CustomerNFT'

export const CustomerChakraNFT = chakra(CustomerNFT);